import request from "@/api/request";

export default {

    // 操作日志

    getList: async data => request({url: '/console/main.Log/getList', data})
}
